import type { FaireProductEntity } from "../../entity_types/product";

export const p_a7h3l3du21: FaireProductEntity = {
  token: "p_a7h3l3du21",
  type: "product",
  name: "French Lavender Bundle",
  brandToken: "b_3ga4euf8eq",
  brandName: "Andaluca",
  imageUrl:
    "https://cdn.faire.com/fastly/80da914c001548d291db2984d3dd0aea377785b2c4430f1323694f6daa0ffa02.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5280cd1a0ea464cf27f49d941c60dee98cb12ef28ffb821cda1751959b4aea5.jpeg",
    "https://cdn.faire.com/fastly/26dafbe0b779fb09ccf42ceae9efe70d0f9137823e93f0cf13183e18741a74b1.jpeg",
    "https://cdn.faire.com/fastly/6cc255d84e61c462e4d3674c4fc64a52cdde85ebc9aa3bfe12c7a2f38741b655.jpeg",
    "https://cdn.faire.com/fastly/a85402873a5ee8448df53f7ff660b17f1e84f9de3a11c17a80cf872b6d9b9457.jpeg",
    "https://cdn.faire.com/fastly/a6102df2ce655312225a29f83bb34cb20dcce1f71ff2a66bfe24728a23dfeadb.jpeg",
    "https://cdn.faire.com/fastly/7c8fb70d4d5d8b82bb0c71727e549abf44610562f94be994f0a03cd17175f5f9.jpeg",
  ],
  priceDollars: 13,
  description:
    "Our dried lavender is sourced direct from the field of Provence, France where growing, harvesting and drying lavender is an age old tradition. This dried lavender has a wonderful natural aroma and is sure to be stunning in your boutique, wrapped in gorgeous thick indented kraft paper for a farmer's market look.\n\n• Please note that some lavender buds will fall of during transportation.\n• Each bundle is approximately 3 oz\n• Approx 15\" length",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:56.998Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
